import { INewsLoggable } from '../strategy-pattern-login/iNews-loggable';
import { Injectable } from '@angular/core';
import { HttpService } from '@services/http-service';
import { ConfigService } from '@services/webFeeder/config.service';
import { Observable , of } from 'rxjs';
import { DatePipe } from '@angular/common';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class INewsWso2Service implements INewsLoggable {


  constructor(
    private _httpService: HttpService,
    private _configService: ConfigService,
    private datePipe: DatePipe
  ) {
  }

  public getNewsByParameters(text: string, agency: string, dateStart: Date, dateEnd: Date): Observable<any> {
    const dateStartTemp = this.datePipe.transform(dateStart, 'ddMMyyyy') + '000000';
    const dateEndTemp = this.datePipe.transform(dateEnd, 'ddMMyyyy') + '235959';
    return this._httpService
      .doGet(this._configService.getApiWebFeederRest(), 'services/news/newsByDate/' + dateStartTemp + '/' + dateEndTemp, false)
      .pipe(map(response => {
        if (response) {
          return response;
        }
        return [];
      }));
  }

}
